<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper2.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="1" :rightBars="rightBars"></menutree>
    <div class="aboutus_content_box">
      <div class="aboutus_content">
        <div style="font-weight: bolder;">
          1、安全风险管控体系
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《中华人民共和国安全生产法》第四条的规定提供安全风险管控体系建设服务：生产经营单位必须遵守本法和其他有关安全生产的法律、法规，加强安全生产管理，建立健全全员安全生产责任制和安全生产规章制度，加大对安全生产资金、物资、技术、人员的投入保障力度，改善安全生产条件，加强安全生产标准化、信息化建设，构建安全风险分级管控和隐患排查治理双重预防机制，健全风险防范化解机制，提高安全生产水平，确保安全生产。
        </p>
        <div style="font-weight: bolder;">
          2、安全生产隐患排查与治理
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《中华人民共和国安全生产法》第四条的规定提供安全生产隐患排查与治理服务：生产经营单位必须遵守本法和其他有关安全生产的法律、法规，加强安全生产管理，建立健全全员安全生产责任制和安全生产规章制度，加大对安全生产资金、物资、技术、人员的投入保障力度，改善安全生产条件，加强安全生产标准化、信息化建设，构建安全风险分级管控和隐患排查治理双重预防机制，健全风险防范化解机制，提高安全生产水平，确保安全生产。
        </p>
        <div style="font-weight: bolder;">
          3、安全标准化
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《中华人民共和国安全生产法》第四条的规定提供安全标准化服务：生产经营单位必须遵守本法和其他有关安全生产的法律、法规，加强安全生产管理，建立健全全员安全生产责任制和安全生产规章制度，加大对安全生产资金、物资、技术、人员的投入保障力度，改善安全生产条件，加强安全生产标准化、信息化建设，构建安全风险分级管控和隐患排查治理双重预防机制，健全风险防范化解机制，提高安全生产水平，确保安全生产。
        </p>
        <div style="font-weight: bolder;">
          4、安全应急预案
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《中华人民共和国安全生产法》第八十一条的规定提供安全预案服务：生产经营单位应当制定本单位生产安全事故应急救援预案，与所在地县级以上地方人民政府组织制定的生产安全事故应急救援预案相衔接，并定期组织演练。
        </p>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      menuchild:[{
        lable:'职业卫生检测与评价',
        value:'2',
        path:'/occupationalHygiene'
      },{
        lable:'安全技术服务',
        value:'1',
        path:'/safetyAssessment'
      },{
        lable:'环保技术服务',
        value:'3',
        path:'/environmentDetection'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'服务项目',
        path:'',
      },{
        lable:'安全技术服务',
        path:'',
      }]
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .aboutus_content_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .aboutus_content{
      width: 1200px;
      min-height: 700px;
      padding:40px 0;
      font-size: 15px;
      color: #666;
      line-height: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/serviceItems/safetyAssessment.vue